var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5477 8.38548C6.50871 8.34645 6.50869 8.28322 6.54766 8.24417L10.0611 4.72368C10.3537 4.43049 10.3532 3.95562 10.06 3.66302C9.76686 3.37042 9.29199 3.37089 8.99939 3.66408L4.88643 7.78529C4.59383 8.07848 4.5943 8.55335 4.88749 8.84595C4.88846 8.84692 4.88944 8.84789 4.89042 8.84886L8.99965 12.9627C9.29238 13.2557 9.76725 13.256 10.0603 12.9632C10.3534 12.6705 10.3536 12.1956 10.0609 11.9026L6.5477 8.38548Z",
    fill: "#B0B3BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.52937bce00afff803600f4ff973a18d7.svg";
export { ForwardRef as ReactComponent };